import React, {useEffect, useRef} from 'react'
import styled from 'styled-components'
import { init } from 'ityped';
import { Link } from 'react-router-dom';
import alb from '../images/albania.svg';
import ita from '../images/italy.svg';
import eng from '../images/united-kingdom.svg';


const Container = styled.div`
    width: 90%;
    height: calc(100vh - 160px);
    overflow-x: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 0 auto;
`;


const ImgContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const Img = styled.img`
    max-width: 80px;
    width: 100%;
    border-radius: 50%;
    margin: 15px;
`

const Text = styled.div`
    height: 50px;
    width: 100%;
`

const TextString = styled.h1`
    font-size: 20px;
    text-align: center;
    color: #f9f9f9;
`

const Span = styled.span``;

function LandingPage() {
    const textRef = useRef()

    useEffect(() => {
        init(textRef.current, {
            showCursor: true,
            typeSpeed:  40,
            backDelay: 300,
            loop: true,
            strings: ["Ju lutem zgjidhni gjuhën!", "Si prega di selezionare la lingua!", "Please choose the language!"]
        })
    }, [])

    return (
        <Container>
            <Text>
                <TextString><Span ref={textRef}></Span></TextString>
            </Text>
            <ImgContainer>
                <Link to='/menu-shqip'><Img src={alb} /></Link>
                <Link to='/menu-italiano'><Img src={ita} /></Link>
                <Link to='/menu-english'><Img src={eng} /></Link>
            </ImgContainer>
        </Container>
    )
}

export default LandingPage
